<template>
<vs-tabs >
  <vs-tab :label="$tc('message.salaryProject.tabs', 0)">
    <Employees />
  </vs-tab>
  <vs-tab :label="$tc('message.salaryProject.tabs', 1)">
    <Payouts />
  </vs-tab>
  <vs-tab :label="$tc('message.salaryProject.tabs', 2)" v-if="false">

  </vs-tab>
</vs-tabs>
</template>

<script>
import Employees from '@/layouts/components/salaryProject/Employees'
import Payouts from '@/layouts/components/salaryProject/Payouts'
import { mapGetters } from 'vuex'

export default {
  name: 'SalaryProject',
  computed: {
    ...mapGetters('utils', ['getSalaryAccount'])
  },
  components: {Employees, Payouts},
  created () {
    window.setTimeout(() => {
      if (!this.getSalaryAccount && this.getSalaryAccount.length === 0) {
        this.$router.push({name: 'noSalaryContract'})
      }
    }, 2000)
  }
}
</script>

<style scoped>

</style>
